import * as React from "react"

const Label = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 45.45 45.23" {...props}>
    <title>{"parcel-journey-2-label-icon-2"}</title>
    <path
      d="M45.45 36.8A8.42 8.42 0 0 1 37 45.23H8a8.42 8.42 0 0 1-8-8V0h37.24v28.39a8.41 8.41 0 0 1 8.21 8.41Zm-8.59-5H15.19a8.4 8.4 0 0 1 0 10h21.67a5 5 0 1 0 0-10Zm-28.44-.54A5.54 5.54 0 1 0 14 36.8a5.54 5.54 0 0 0-5.58-5.54Zm-.67-6.15h21.53a2.65 2.65 0 0 0 2.64-2.65V8a2.65 2.65 0 0 0-2.64-2.65H7.75A2.65 2.65 0 0 0 5.1 8v14.46a2.65 2.65 0 0 0 2.65 2.65Zm21-15.47H8.15v2h20.61Zm0 4.33H8.15v2h20.61Zm0 4.32H8.15v2h20.61Zm10.66 17.29H18.79v2h20.62Z"
      fill="#4ead90"
    />
  </svg>
)

export default Label
